if (!window.customElements.get('product-card-variant-form')) {
  class ProductCardVariantForm extends HTMLElement {
    connectedCallback() {
      this.variants = JSON.parse(this.querySelector('[data-product-variants]')?.textContent || '[]');
      this.optionsConfig = JSON.parse(this.querySelector('[data-product-options]')?.textContent || '{}');
      this.form = this.querySelector('form');
      this.variantInput = this.form?.querySelector('input[name="id"]');
      this.atcButton = this.form?.querySelector('.product-card-variants__atc');
      this.atcPriceEl = this.atcButton?.querySelector('[data-atc-price]');

      this.pillInputs = this.querySelectorAll('input[name^="pill-option-"]');
      this.dropdownSelect = this.querySelector('select[name^="dropdown-option-"]');

      this.normalizeCurrencyLabels();

      this.pillInputs.forEach(input => {
        input.addEventListener('change', () => this.onOptionChange());
      });

      if (this.dropdownSelect) {
        this.dropdownSelect.addEventListener('change', () => this.onOptionChange());
      }

      this.form?.addEventListener('submit', (e) => this.onSubmit(e));
    }


    normalizeCurrencyLabels() {
  this.querySelectorAll('.product-card-variants__pill').forEach(label => {
    const walker = document.createTreeWalker(
      label,
      NodeFilter.SHOW_TEXT
    );

    const textNodes = [];
    let currentNode;

    while ((currentNode = walker.nextNode())) {
      textNodes.push(currentNode);
    }

    textNodes.forEach(node => {
      let text = node.textContent;

      text = text.replace(
        /\bDKK\s*([\d.,]+)/gi,
        function(match, amount) {
          return amount.replace(/\.00$/, ',00') + ' DKK';
        }
      );

      text = text.replace(
        /\b([\d.,]+)\s*kr\.?/gi,
        function(match, amount) {
          return amount.replace(/\.00$/, ',00') + ' DKK';
        }
      );

      node.textContent = text;
    });
  });
}

    getSelectedOptions() {
      const options = {};

      this.pillInputs.forEach(input => {
        if (input.checked) {
          const pos = parseInt(input.dataset.optionPosition);
          options[pos] = input.value;
        }
      });

      if (this.dropdownSelect) {
        const pos = parseInt(this.dropdownSelect.dataset.optionPosition);
        options[pos] = this.dropdownSelect.value;
      }

      return options;
    }

    findVariant(options) {
      return this.variants.find(variant => {
        return Object.keys(options).every(pos => {
          const idx = parseInt(pos) - 1;
          return variant.options[idx] === options[pos];
        });
      });
    }

    onOptionChange() {
      const selectedOptions = this.getSelectedOptions();

      this.updatePillStyles();

      const allPositions = [];
      if (this.optionsConfig.pill_position) allPositions.push(this.optionsConfig.pill_position);
      if (this.optionsConfig.dropdown_position) allPositions.push(this.optionsConfig.dropdown_position);

      const allSelected = allPositions.every(pos => selectedOptions[pos] != null);

      if (allSelected) {
        const variant = this.findVariant(selectedOptions);
        if (variant) {
          this.variantInput.value = variant.id;
          this.atcButton.disabled = !variant.available;
          this.updateAtcPrice(variant);
        } else {
          this.atcButton.disabled = true;
        }
      }
    }

    updatePillStyles() {
      this.querySelectorAll('.product-card-variants__pill').forEach(label => {
        const input = label.querySelector('input[type="radio"]');
        label.classList.toggle('product-card-variants__pill--selected', input.checked);
      });
    }

    updateAtcPrice(variant) {
      if (!this.atcPriceEl) return;
      this.atcPriceEl.textContent = this.formatMoney(variant.price);
    }

    formatMoney(cents) {
      const settings = window.themeVariables?.settings;
      const format = settings?.currencyCodeEnabled
        ? settings.moneyWithCurrencyFormat
        : settings.moneyFormat;

      if (!format) return Math.round(cents / 100).toString();

      const formatted = format
        .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, this.numberWithCommas(cents / 100, '.', ','))
        .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, this.numberWithCommas(Math.round(cents / 100), '.', ','))
        .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, Math.round(cents / 100).toLocaleString())
        .replace(/\{\{\s*amount\s*\}\}/g, (cents / 100).toFixed(2));

      return formatted.replace(/,00\b/, '').replace(/\.00\b/, '');
    }

    numberWithCommas(number, thousandSep, decimalSep) {
      const parts = number.toFixed(2).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousandSep);
      return parts.join(decimalSep);
    }

    async onSubmit(event) {
      event.preventDefault();

      const submitButton = this.atcButton;
      if (submitButton.getAttribute('aria-busy') === 'true' || submitButton.disabled) return;

      submitButton.setAttribute('aria-busy', 'true');

      let sectionsToBundle = new Set();
      document.documentElement.dispatchEvent(
        new CustomEvent('cart:prepare-bundled-sections', { bubbles: true, detail: { sections: sectionsToBundle } })
      );

      const formData = new FormData(this.form);
      formData.delete('pill-option-' + this.optionsConfig.pill_position);
      if (this.optionsConfig.dropdown_position) {
        formData.delete('dropdown-option-' + this.optionsConfig.dropdown_position);
      }
      formData.set('sections', [...sectionsToBundle].join(','));

      document.documentElement.dispatchEvent(new CustomEvent('theme:loading:start', { bubbles: true }));

      try {
        const response = await fetch(`${Shopify.routes.root}cart/add.js`, {
          body: formData,
          method: 'POST',
          headers: { 'X-Requested-With': 'XMLHttpRequest' }
        });

        const responseJson = await response.json();

        document.documentElement.dispatchEvent(new CustomEvent('theme:loading:end', { bubbles: true }));
        submitButton.removeAttribute('aria-busy');

        if (response.ok) {
          if (window.themeVariables.settings.cartType === 'page' || window.themeVariables.settings.pageType === 'cart') {
            window.location.href = `${Shopify.routes.root}cart`;
            return;
          }

          const cartContent = await (await fetch(`${Shopify.routes.root}cart.js`)).json();
          cartContent['sections'] = responseJson['sections'];
          const items = responseJson.hasOwnProperty('items') ? responseJson['items'] : [responseJson];

          this.form.dispatchEvent(new CustomEvent('variant:add', {
            bubbles: true,
            detail: { items, cart: cartContent }
          }));

          document.documentElement.dispatchEvent(new CustomEvent('cart:change', {
            bubbles: true,
            detail: { baseEvent: 'variant:add', cart: cartContent }
          }));

          if (window.themeVariables.settings.cartType === 'message') {
            document.dispatchEvent(new CustomEvent('toast:show', {
              detail: { message: window.themeVariables.strings.addedToCart.replace('{{product_title}}', items?.[0]?.title) }
            }));
          }
        } else {
          this.form.dispatchEvent(new CustomEvent('cart:error', {
            bubbles: true,
            detail: { error: responseJson['message'] }
          }));

          document.dispatchEvent(new CustomEvent('toast:show', {
            detail: { message: responseJson['message'], tone: 'error' }
          }));

          document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        }
      } catch (err) {
        document.documentElement.dispatchEvent(new CustomEvent('theme:loading:end', { bubbles: true }));
        submitButton.removeAttribute('aria-busy');
      }
    }
  }

  window.customElements.define('product-card-variant-form', ProductCardVariantForm);
}
